import * as ActionTypes from './actionTypes.js';
import Axios from './../common/helpers/axiosUtil';

const NOTIFICATION_URL = `/apps/ptb/api/notifications`;

export function updateComponentState(type, payload) {
    return { type, payload };
}

export function fetchNotifications(userProfile) {
    const request_params = collectNotificationParams(userProfile);
    return dispatch => {
        Axios.post(NOTIFICATION_URL, request_params)
            .then(response => {
                dispatch(updateComponentState(ActionTypes.FETCH_NOTIFICATIONS_SUCCESS, { notification_list: filterNotifications(response, userProfile) }));
            })
            .catch(err => {
                dispatch(updateComponentState(ActionTypes.FETCH_NOTIFICATIONS_FAILED, { notification_list: [] }));
            });
    };
}
export function resetNotifications(params) {
    return dispatch => {
        dispatch(updateComponentState(ActionTypes.RESET_NOTIFICATIONS, { notification_list: [] }));
    };
}
export function hideSidebar() {
    return dispatch => {
        dispatch(
            updateComponentState(ActionTypes.HIDE_SIDEBAR)
        );
    };
}
export function hideSidebarAndClearData() {
    return dispatch => {
        dispatch(
            updateComponentState(ActionTypes.HIDE_SIDEBAR_AND_CLEAR_DATA)
        );
    };
}
export function showSidebar(params) {
    return dispatch => {
        dispatch(
            updateComponentState(ActionTypes.SHOW_SIDEBAR, params)
        );
    };
}

function collectNotificationParams(userProfile) {
    let request_params = {};
    request_params.taxId = userProfile.producer.encryptedTaxId;
    const productPromotionsData = () => {
        const { producer: { appointedStates, lineOfBusiness } } = userProfile;
        let uniqueLob = []
        for (let state in lineOfBusiness) {
            let tempArr = [...uniqueLob, ...lineOfBusiness[state]];
            uniqueLob = [...new Set(tempArr)]
        }

        const mappedLob = mapLineOfBuisiness(uniqueLob);
        const selectedStatesData = appointedStates?.join(',');
        const selectedLobData = mappedLob?.join(',');
        let messageType = 'Product Promotion';

        request_params.product_promotions = {
            selectedStatesData,
            messageType,
            selectedLobData,
        };
    }
    productPromotionsData();
    return request_params;
}

function mapLineOfBuisiness(lobArr) {
  return (
    lobArr &&
    lobArr?.map(lob => {
      switch (lob?.toLowerCase()) {
        case 'individual':
          return 'IND';
        case 'largegroup':
          return 'LG';
        case 'smallgroup':
          return 'SM';
        default:
          return lob;
      }
    })
  );
}
function filterNotifications(messages, userProfile) {
    const filterCriteria = new FilterCriteria(messages, userProfile);
    let allMessages = [];

    allMessages = messages.filter((messageObj, index) => {
        if (messageObj.type === 'promotion') {
            return filterCriteria.productPromotions(index);
        } else {
            return true;
        }
    });
    return allMessages;
}

class FilterCriteria {
    constructor(notifications, userProfile) {
        this.notifications = notifications;
        this.userProfile = userProfile;
    }

    productPromotions = (index) => {
        const messageObj = this.notifications[index];

        if (messageObj.metadata && messageObj.metadata.state && messageObj.metadata.lineofbusiness) {
            let messageState = messageObj.metadata.state;
            let messageLob = messageObj.metadata.lineofbusiness;

            const { producer: { lineOfBusiness } } = this.userProfile;
            let isMessageValid = false;

            if (messageLob && messageState) {
                messageState.map((state, ind) => {
                    if (lineOfBusiness[state]) {
                        const lobMappedValues = mapLineOfBuisiness(lineOfBusiness[state]);
                        messageLob.map((lob, i) => {
                            if (lobMappedValues.indexOf(lob) > -1) {
                                isMessageValid = true;
                            }
                        });
                    }
                });
            } else {
                isMessageValid = true;
            }
            return isMessageValid;
        }
    }
}